import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CustomService } from '@/shared/services/custom.service';
import { TipoDocumentoEspecialidadeResponse } from './especialidade.model';

@Injectable({
    providedIn: 'root'
})
export class EspecialidadeTiposDocumentoService extends CustomService {
    private readonly apiUrlTiposDocumento = environment.apis.apiSicom + '/api/v1/cadastro/medico/tipos-documento-especialidade';

    private readonly http = inject(HttpClient);

    /**
     * Lista os Tipos de Documento de Especialidade.
     * GET /api/v1/cadastro/medico/tipos-documento-especialidade
     */
    listarTiposDocumentoEspecialidade(): Observable<TipoDocumentoEspecialidadeResponse[]> {
        return this.http.get<TipoDocumentoEspecialidadeResponse[]>(this.apiUrlTiposDocumento).pipe(catchError(this.handleError));
    }
}
